var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('span',[_c('v-layout',{staticClass:"progress-bg",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"green","indeterminate":""}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }